export default __webpack_public_path__ + "static/media/notify_top.ef4fbd5f.svg";